// extracted by mini-css-extract-plugin
export default {"title":"settingsEditor_title__c6Mnh","type":"settingsEditor_type__5Eqs0","root":"settingsEditor_root__yy+iz","filters":"settingsEditor_filters__63A++"};